"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.verify = exports.sign = void 0;
const jsonwebtoken_1 = require("jsonwebtoken");
var jsonwebtoken_2 = require("jsonwebtoken");
Object.defineProperty(exports, "decode", { enumerable: true, get: function () { return jsonwebtoken_2.decode; } });
const SECRET = `-----BEGIN RSA PRIVATE KEY-----
MIIEpAIBAAKCAQEA1d8dAjL+O77xnpOCwN2WT99VIIIAH0jvmRCk2XcUAaGpeP+4
2nH2eAt3/WFHr1nitzeLw5KOlNT6pc/dEiQaDPkJfmwj1exBmDVJBkpqATPIvKJy
YTeL0/57hiLvhpRnnkmAI6POjkTCOVhnozyRtZEgjyQ6/eVpKVJMU+qKl/+x2igf
o+L09lrtdUU3ew6XtHSMki5c8O60gCSS3Py0WVQkWLdlgLLQC6iengU0QgvKi46y
lIE3mANn1P5/tnGezCajDTqwiayDM54T6O/N5StNzNfIbyvzuIwcS9hOq1cb4LD7
g5ppRG2pGQkovJ5KY3N8iQxYw2gyo7huNj3QBQIDAQABAoIBABh0qNaFiji+vtZJ
O9xd+kAr44oSE32AU5WHJ7KOQUVmfQCPDU49VdeoSBI7O307pAcbXOoCKjeumvK2
8CqQ4kG1gHZqWzatC1siTLVhcPmuODgJw1aGiYC2St2txQH4mlipQvPQWWA/UI5K
I5+w32CJtdVoaS57Oyk0dfHqkeqLZv2zOq4QVM7hj1qmHbBE/A7GzLRyzrQd7zPB
PGKZKfpZWVmi7zUspK7cG3ZdeJJB6nlMzHu5+K+ZnHxw3HhiqbRmvpQuL7tXJ/hB
ec0GFnYw37HvNODlZ6u+27hJCYP4jZOzHERCNlc2C36KcrKAWQ+dU9BsljsXbrp+
etM9t0kCgYEA76DwZA2qMDKwGlLFjsRvVVeqBcWP4CIJH6UAA7HaFlA1sZBQvSlF
V8t1y7OE1purQ4w6v+cOiR586TrgCIF3WXmMfMr4AlPVsn0N4UWv32JrJWM37RXr
I5SPcpocmK8igpL1Dqz5zXpae5B4vJsGoNege+DCCCPbS/3Te+4yMP8CgYEA5Huv
1CNoSlwC4gWMbHDX0W97XB/IZcCYicxwUqQ3TIt/v4rVciizb4XKfHkxWrirp+L/
2hBcmYPDbyjdUwW6l50OmpQVUXI0cGZw+RgVP5lAQ6UrelQwDhGXJ9g9mLWPElxD
VtOJW9w8NwKWh21ktaPtqtqynoVCGGNx2SYSOvsCgYEAj2ob1VXUUIpVmTuGnz5z
f3k6+b9Wr4bPPRAsZQmxg38303CS0dN8e+H6OxLS4vpB0uh/VND9gxUrHw8sfAq4
GmXDrgBv1DzGfc+YWgWyD5jAlZy/IPboRuAnxif0C3FtzwYTAliGHPMoaiF6ES8b
FXJXyywmFGcZXW6pftd9VJMCgYAP7O8cgjtKs48f4fMfu93PI04d5bk6HmqDcFSD
7h5Mn4yP9UVbZ6raIyEx++CMykJsuU3MDUfnC2Ab52VF3ChdWP0jmR7DRoqRKxLE
ygDxJeVs0Z5uMGAJGwDGLjRc6IrIZNXsv2HbnUY1L2D+n4ldf8eZGRVKJ0+sE4Jj
+Ftc8QKBgQC0uXzpx34sZY6oF7pi7jqNXAJEqpTre0DY/UWUaTuA4jF2Q/k+qGpp
cShexJOyO7dReJHamLkLukDooFTYh2YZxWTkd2WQad7PlSOAcxLrlCXJSF521s5s
S+ran9NMntEGZNMXzBnAJIKMqmZ+ryu5Fo0Uh3NoxZXIcCAPV/Qkaw==
-----END RSA PRIVATE KEY-----`;
exports.sign = (data) => jsonwebtoken_1.sign(data, SECRET);
exports.verify = (data) => {
    try {
        return jsonwebtoken_1.verify(data, SECRET);
    }
    catch (error) {
        return null;
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/server/jwt.ts
// module id = 2460
// module chunks = 0 2